/*global WebView, ImporterController*/

module.exports = [
    {   
        type: "preNavigation", //called before app navigation
        interceptor: function (app, context, callback) {
            if(context.destination && context.destination[0] === "~"){
                //opening a popup, don't check
                return callback() ;
            }
            if(!app.currentRoute){ return callback() ;}
            var routes = app._getRoutes(app.currentRoute) ;
            if(routes.length>2 && routes[routes.length-1].urlPosition === routes[routes.length-2].urlPosition ){
                //closing a popup, don't check
                return callback() ;
            }
            var editingControllers = Object.keys(app.context.controllers).filter(function(c){ 
                var controller = app.context.controllers[c] ;
                if(controller instanceof ImporterController){
                    return false;
                }
                if(controller.noLeaveAlert){
                    return false;
                }
                var mode = controller.mode ;
                if(controller.formController){
                    mode = controller.formController.mode ;
                }
                return mode === "create" ||mode === "modify"; 
            }) ;
            if(editingControllers.length>0){
                WebView.confirm(WebView.tr("global.areYouSureLeaveInput"), function(yes){
                    if(yes){
                        editingControllers.forEach(function(c){
                            var controller = app.context.controllers[c] ;
                            if(controller.mode){
                                controller.mode = "read" ;
                            } else if(controller.formController){
                                controller.formController.mode = "read" ;
                            }
                        }) ;
                        callback() ;
                    }else{
                        callback(null, true) ;
                    }
                }.bind(this)) ;
            }else{
                callback() ;
            }
        }
    }
];